import { SET_LIST_PAGINATION, RESET_LIST_PAGINATION_PAGE } from "./listPaginationTypes";

const defaultListState = () => ({ page: 0, rowsPerPage: 25 });

const initialState = {
  myJobs: { page: 0, rowsPerPage: 25 },
  announcements: { page: 0, rowsPerPage: 10 },
  tradesperson: { page: 0, rowsPerPage: 25 },
  compliance: { page: 0, rowsPerPage: 25 },
  listings: { page: 0, rowsPerPage: 25 }
};

const listPaginationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LIST_PAGINATION: {
      const { listKey, page, rowsPerPage } = action.payload;
      if (!listKey || !Object.prototype.hasOwnProperty.call(state, listKey)) return state;
      const current = state[listKey] || defaultListState();
      return {
        ...state,
        [listKey]: {
          ...current,
          ...(page !== undefined && { page }),
          ...(rowsPerPage !== undefined && { rowsPerPage })
        }
      };
    }
    case RESET_LIST_PAGINATION_PAGE: {
      const { listKey } = action.payload;
      if (!listKey || !Object.prototype.hasOwnProperty.call(state, listKey)) return state;
      return {
        ...state,
        [listKey]: {
          ...state[listKey],
          page: 0
        }
      };
    }
    default:
      return state;
  }
};

export default listPaginationReducer;
